var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "#7B6D9B",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_2852",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_2852)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_2852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9948 22.7333C57.475 21.6318 58.6676 31.9994 58.2039 37.3208C57.8865 40.0489 55.9559 44.393 51.0721 47.6185C52.2391 51.0138 51.8375 54.9553 48.9299 57.0613C37.3078 65.4793 15.0971 61.2665 11.2206 54.9724C6.34411 47.0545 13.1039 36.4868 13.3699 27.1916L13.4424 24.6563C13.6873 21.0741 16.1146 14.7869 23.4101 12.7098C27.8421 11.448 33.1399 12.3459 35.6804 16.1905C37.9603 19.6407 38.6501 23.7933 43.4118 24.2087C45.2626 23.4987 47.1455 22.9735 48.9948 22.7333Z",
    fill: "url(#paint0_linear_24_2852)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 25.211,
    cy: 24.97,
    r: 6.46749,
    transform: "rotate(-7.40054 25.211 24.97)",
    fill: "url(#paint1_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.0128,
    cy: 24.866,
    r: 6.46749,
    transform: "rotate(-7.40054 26.0128 24.866)",
    fill: "url(#paint2_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8591 28.775L24.4593 18.587C24.694 18.5292 24.9343 18.484 25.1797 18.4521C25.824 18.3685 26.4586 18.3827 27.0682 18.4833L22.8242 30.4931C22.0622 30.0606 21.3919 29.4761 20.8591 28.775Z",
    fill: "url(#paint3_linear_24_2852)",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6082 31.1808L28.8874 19.0716C29.1896 19.2219 29.4792 19.3954 29.7535 19.59L25.6077 31.3219C25.268 31.3009 24.934 31.2533 24.6082 31.1808Z",
    fill: "url(#paint4_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5449,
    cy: 20.9285,
    r: 6.46749,
    transform: "rotate(-7.40054 38.5449 20.9285)",
    fill: "url(#paint5_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.3467,
    cy: 20.8245,
    r: 6.46749,
    transform: "rotate(-7.40054 39.3467 20.8245)",
    fill: "url(#paint6_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1929 24.7337L37.7931 14.5458C38.0278 14.488 38.2682 14.4428 38.5136 14.4109C39.1579 14.3272 39.7924 14.3414 40.4021 14.442L36.1581 26.4518C35.3961 26.0192 34.7257 25.4347 34.1929 24.7337Z",
    fill: "url(#paint7_linear_24_2852)",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9425 27.1393L42.2216 15.0301C42.5238 15.1804 42.8134 15.3538 43.0878 15.5485L38.942 27.2804C38.6022 27.2595 38.2683 27.2118 37.9425 27.1393Z",
    fill: "url(#paint8_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7547 22.9721C54.7654 23.2326 54.7351 23.4869 54.6687 23.7307C58.8723 26.6622 60.0516 33.9902 59.7032 37.9879C59.3858 40.7159 57.4552 45.06 52.5714 48.2856C49.0583 50.6059 42.9913 52.8939 35.8987 51.6375C28.806 50.3811 24.5804 41.5585 28.2382 34.154C28.7019 33.2154 29.1923 32.3929 29.7089 31.6669C29.6853 31.6266 29.6626 31.5857 29.6407 31.544C28.7444 29.8353 29.6506 27.5936 31.6649 26.537C33.2172 25.7227 34.9745 25.8499 36.1092 26.7332C37.3471 26.217 38.6603 25.7898 40.0446 25.3395L40.0446 25.3395C41.2626 24.9433 42.5355 24.5291 43.8606 24.0208C45.0873 23.5502 46.3282 23.1608 47.5641 22.8817C47.7324 21.412 49.1989 20.2219 51.0309 20.147C53.0204 20.0657 54.6877 21.3305 54.7547 22.9721Z",
    fill: "url(#paint9_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.3286,
    cy: 28.7223,
    rx: 2.67233,
    ry: 3.43585,
    transform: "rotate(-14.912 52.3286 28.7223)",
    fill: "url(#paint10_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.9132,
    cy: 34.4524,
    rx: 3.05409,
    ry: 3.81762,
    transform: "rotate(-16.9069 35.9132 34.4524)",
    fill: "url(#paint11_linear_24_2852)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24_2852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3834 14.2613C32.1189 13.5909 30.8145 12.9969 30.1953 12.7836C29.6552 8.62532 29.8133 8.13495 30.8664 7.70453C33.702 7.33623 36.882 11.3278 35.8664 12.047C34.8157 13.0644 32.648 14.9317 32.3834 14.2613Z",
    fill: "url(#paint12_linear_24_2852)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_24_2852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2985 12.0082C20.549 14.8503 19.7677 18.1268 19.0957 19.4098C18.6587 19.9394 17.6204 20.9032 16.9628 20.522C16.1409 20.0455 11.6554 16.3775 11.4676 15.7348C11.3174 15.2207 11.4334 14.683 11.5101 14.4784C12.8352 12.4708 16.048 9.16614 18.2985 12.0082Z",
    fill: "url(#paint13_linear_24_2852)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_2852",
    x: -70.5422,
    y: -63.825,
    width: 208.832,
    height: 209.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.709804 0 0 0 0 0.180392 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_2852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_2852",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24_2852",
    x: -50.1075,
    y: -68.3193,
    width: 166.167,
    height: 166.722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.709804 0 0 0 0 0.180392 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_2852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_2852",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_24_2852",
    x: -68.6054,
    y: -65.0969,
    width: 168.398,
    height: 169.706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.709804 0 0 0 0 0.180392 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_2852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_2852",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_2852",
    x1: 30.7143,
    y1: 23.857,
    x2: 26.4285,
    y2: 62.4284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED467",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_2852",
    x1: 25.211,
    y1: 18.5025,
    x2: 25.211,
    y2: 31.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120E1D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_2852",
    x1: 26.0128,
    y1: 18.3985,
    x2: 26.0128,
    y2: 31.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543E05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24_2852",
    x1: 25.208,
    y1: 18.7,
    x2: 23.134,
    y2: 30.9463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24_2852",
    x1: 29.5006,
    y1: 20.3368,
    x2: 28.4284,
    y2: 31.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24_2852",
    x1: 38.5449,
    y1: 14.461,
    x2: 38.5449,
    y2: 27.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120E1D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_24_2852",
    x1: 39.3467,
    y1: 14.357,
    x2: 39.3467,
    y2: 27.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543E05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_24_2852",
    x1: 38.5418,
    y1: 14.6587,
    x2: 36.4678,
    y2: 26.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_24_2852",
    x1: 42.8349,
    y1: 16.2952,
    x2: 41.7626,
    y2: 27.0325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_24_2852",
    x1: 41.42,
    y1: 23.2816,
    x2: 31.004,
    y2: 49.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDEBB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#FCD148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF02",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_24_2852",
    x1: 52.3286,
    y1: 25.2865,
    x2: 52.3286,
    y2: 32.1582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_24_2852",
    x1: 35.9132,
    y1: 30.6348,
    x2: 35.9132,
    y2: 38.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_24_2852",
    x1: 35.8204,
    y1: 10.5222,
    x2: 29.9998,
    y2: 11.2782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED467"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_24_2852",
    x1: 19.4392,
    y1: 18.9529,
    x2: 13.4089,
    y2: 12.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED467"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg);
export default __webpack_public_path__ + "static/media/headerImg.f3c22dc00d8d944f1302bfd948a7d19e.svg";
export { ForwardRef as ReactComponent };